import { serviceRoutes, post, get } from "./index";

export async function actualizarFechas(body) {
  return await post(serviceRoutes.actualizarFechasAnualidad, body);
}

export const consultarAnualidad = async (idEmisor) =>
  await get(serviceRoutes.consultarAnualidad, `?emisor=${idEmisor}`);
